import {withRetry} from "ui-common/api/OpenClient";
import {v3_client} from "../../../api/OpenClient";

export const saveMugshot = async ({mugshotData, tokenData}) => {
  const request = {
    method: "post",
    url: "/mugshots",
    data: {
      token: tokenData.token,
      hme_org_code: tokenData.hme_org_code,
      hme_location_code: tokenData.hme_location_code,
      patient_code: tokenData.patient_code,
      base64_image_url: mugshotData.base64ImageUrl,
      direction: mugshotData.direction
    }
  }

  try {
    const response = await withRetry(() => v3_client(request));
    console.debug("Saved mugshot", response)
  } catch (e) {
    // Since this API is only intended in the dev environment, and is best-effort,
    // just warn of any failure and move on.
    console.warn("Failed to save mugshot", request, e)
  }
}